import { createAction, props } from '@ngrx/store';
import { IProductSolutionResponse, IProductSolutionSearchRequest } from '../models/product-solutions.model';

export const loadSearchProductSolutions = createAction(
  '[SearchProductSolution] Load SearchProductSolutions',
  props<{ param: IProductSolutionSearchRequest }>()
);

export const loadSearchProductSolutionsSuccess = createAction(
  '[SearchProductSolution] Load SearchProductSolutions Success',
  props<{ response: IProductSolutionResponse }>()
);

export const loadSearchProductSolutionsFailure = createAction(
  '[SearchProductSolution] Load SearchProductSolutions Failure',
  props<{ error: any }>()
);
